import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "user-panel background-secondary" }
const _hoisted_2 = { class: "texts fira" }
const _hoisted_3 = { class: "aliceblue" }
const _hoisted_4 = { class: "small faded" }

import { auth } from '@/firebase-config';
import { signOut, type User } from 'firebase/auth';


export default /*@__PURE__*/_defineComponent({
  __name: 'UserPanel',
  props: {
    user: {}
  },
  emits: ["logout"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

function logout() {
  try {
    signOut(auth);
  } catch (error) {
    alert('Error signing out');
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(__props.user?.displayName), 1),
      _createElementVNode("p", _hoisted_4, _toDisplayString(__props.user?.email), 1)
    ]),
    _createElementVNode("button", {
      class: "icon-button",
      onClick: logout
    }, [...(_cache[0] || (_cache[0] = [
      _createElementVNode("span", { class: "material-symbols-outlined aliceblue icon-normal" }, "logout", -1)
    ]))])
  ]))
}
}

})